module.exports = __webpack_public_path__ + "img/5@2x (1).aaabcb6d.png";